import { Link } from 'react-router-dom';

import { Button } from 'antd';

import styles from './styles.module.scss';

import DragIcon from './DragIcon';

function CardHeader({ title, to }) {
  return (
    <div className={styles['card-header']}>
      <div className={styles['header-wrapper']}>
        {to ? (
          <Link className={styles['head-link']} to={to}>
            {title}
          </Link>
        ) : (
          <div className={styles['head-title']}>{title}</div>
        )}
        <Button type="link" size="small" className="drag-handle" icon={<DragIcon />} />
      </div>
    </div>
  );
}

export default CardHeader;
